export default __webpack_public_path__ + "static/media/wikipedia_door.0fe54340.png";